import { BusinessUnitIdParser } from '../index';

interface IDay {
    day: 'numeric' | '2-digit';
}

interface IYear {
    year: 'numeric' | '2-digit';
}

interface IMonth {
    month: 'numeric' | '2-digit' | 'narrow' | 'short' | 'long';
}

interface IDateTokens {
    M: IMonth;
    MM: IMonth;
    MMM: IMonth;
    MMMM: IMonth;
    D: IDay;
    DD: IDay;
    YY: IYear;
    YYYY: IYear;
}

interface IDateLocaleFormat {
    locale: BusinessUnitIdParser['locale'];
    date: Date;
}

export type IDateToken = keyof IDateTokens;

export interface IDateFormatOptions extends IDateLocaleFormat {
    formats: IDay | IMonth | IYear;
}

export interface IDateFormat extends IDateLocaleFormat {
    dateFormat: string;
}

export interface IDate {
    dateFormat?: IDateFormat['dateFormat'];
    date: string;
}

export interface IDateMessageFormat extends IDate {
    message: string;
    placeholderRegex: RegExp;
}

export const dateTokens: IDateTokens = {
    M: { month: 'numeric' },
    MM: { month: '2-digit' },
    MMM: { month: 'short' },
    MMMM: { month: 'long' },
    D: { day: 'numeric' },
    DD: { day: '2-digit' },
    YY: { year: '2-digit' },
    YYYY: { year: 'numeric' }
};

export const defaultDateFormat = 'DD/MM';
export const DateTokenRegex = /[MDY]+/;
export const preorderDatePlaceholderRegex = /::PREORDER_DATE::/gi;
